export default __webpack_public_path__ + "static/media/Gallery_white.b851df9c.svg";